module.exports = __webpack_public_path__ + "static/img/team_mode.79eae0e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/word_quiz/team_mode.png
// module id = qLp3
// module chunks = 1